// extracted by mini-css-extract-plugin
module.exports =  {"main":"---src-pages-Home-Home__main--PJqrO","contentContainer":"---src-pages-Home-Home__contentContainer--jasJ7","content":"---src-pages-Home-Home__content--VWJ1d"};